import { type Address } from "viem";
import { ChainId } from "./chains";

// Define the type for bulk transfer contract mapping
type BulkTransferContractsType = {
  [key in ChainId]?: Address;
};

// ERC721 Bulk Transfer contract addresses for each supported chain
export const bulkTransferContracts: BulkTransferContractsType = {
  [ChainId.SHIBARIUM]: "0xE220Ebb1c1E3D5a5e931be78424d3dF440eb6971",
  [ChainId.DOGECHAIN]: "0x5004Dd89E252fE18c802C9FAD6AB6d82015Bc0d4", // Update with actual address when deployed
  [ChainId.BASE]: "0x1ae79a2A3C96C17A36ae28555F592163ED8136E8", // Update with actual address when deployed
  [ChainId.ETH]: "0x6525a2c0450302b93dd2e8d8406f368eb88f4b79", // Update with actual address when deployed
};

/**
 * Get the bulk transfer contract address for a specific chain
 * @param chainId - The chain ID to get the contract address for
 * @returns The contract address for the specified chain, or undefined if not supported
 */
export const getBulkTransferContract = (chainId: number): Address | undefined => {
  return bulkTransferContracts[chainId as ChainId];
};

/**
 * Check if bulk transfer is supported on a specific chain
 * @param chainId - The chain ID to check
 * @returns True if bulk transfer is supported on the chain
 */
export const isBulkTransferSupported = (chainId: number): boolean => {
  return !!bulkTransferContracts[chainId as ChainId];
};